const state = {
    uId: '',
    defaultConfig: {}
}

const getters = {
    uId: state => state.uId,
    defaultConfig: state => state.defaultConfig
}

const mutations = {
    setuId(state, uId) {
        state.uId = uId 
    },
    setDefaultConfig(state, config) {
        state.defaultConfig = config
    }
}

const actions = {
    setuId({ commit }, uId) {
        commit('setuId', uId)
    },
    setDefaultConfig({ commit }, config) {
        commit('setDefaultConfig', config)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
